import * as luxon from 'luxon';

function isoStringOrDate(value: string | Date): luxon.DateTime {
  if (value instanceof Date) {
    return luxon.DateTime.fromJSDate(value);
  }
  return luxon.DateTime.fromISO(value);
}

export function toMediumDateTime(date: Date | string): string {
  return isoStringOrDate(date).toLocaleString(luxon.DateTime.DATETIME_MED);
}

export function toMediumDate(date: Date | string): string {
  return isoStringOrDate(date).toLocaleString(luxon.DateTime.DATE_MED);
}

// Compact enough for a chart axis, where the year is implied by the range.
export function toMonthDay(date: Date | string): string {
  return isoStringOrDate(date).toLocaleString({
    month: 'numeric',
    day: 'numeric',
  });
}

export function toLongDateTime(date: Date | string): string {
  return isoStringOrDate(date).toLocaleString({
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  });
}

export function isAfter(
  isThis: string | Date,
  afterThis: string | Date,
): boolean {
  return isoStringOrDate(isThis) > isoStringOrDate(afterThis);
}

export function isInTheFuture(date: string | Date): boolean {
  return isAfter(date, new Date());
}

export function fromNow(date: string | Date): string {
  return isoStringOrDate(date).toRelative()!;
}

// Like `fromNow`, but snapped to calendar units, so the recent past reads
// "yesterday"/"today" instead of "23 hours ago". Lowercase, as luxon returns it.
export function fromNowCalendar(date: string | Date): string {
  return isoStringOrDate(date).toRelativeCalendar()!;
}

export function haveSameTimeComponent(
  date1: string | Date,
  date2: string | Date,
): boolean {
  const a = isoStringOrDate(date1);
  const b = isoStringOrDate(date2);
  return (
    a.hour === b.hour &&
    a.minute === b.minute &&
    a.second === b.second &&
    a.millisecond === b.millisecond
  );
}

export function replaceTimeComponent(
  ofDate: string | Date,
  withTimeFrom: string | Date,
): Date {
  const b = isoStringOrDate(withTimeFrom);
  return isoStringOrDate(ofDate)
    .set({
      hour: b.hour,
      minute: b.minute,
      second: b.second,
      millisecond: b.millisecond,
    })
    .toJSDate();
}
